import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ProductIdCellRendererComponentParams {
  titleUrl: string;
  status?: string;
}

@Component({
    template: `<span class="fw-bold mb-1">
    @if(showDiscontinueBadge) {
    <span
      data-test-selector="grid-discontinued-badge"
      class="badge badge-pill bg-secondary"
      >D/C</span
    >
    }
    <a
      [href]="titleUrl"
      target="_blank"
      data-test-selector="three-line-with-title-as-link-anchor"
    >
      {{ value }}
    </a>
  </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductIdCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  showDiscontinueBadge!: boolean;
  titleUrl!: string;
  value?: string;

  agInit({ value, titleUrl, status }: CustomParams): void {
    if (value) this.value = value;
    this.titleUrl = titleUrl;
    this.showDiscontinueBadge = !!(status && status === 'Discontinued');
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}

interface CustomParams
  extends ICellRendererParams<unknown, string>,
    ProductIdCellRendererComponentParams {}
